// prefer default export if available
const preferDefault = m => (m && m.default) || m

exports.components = {
  "component---src-pages-disclaimer-index-js": () => import("./../../../src/pages/disclaimer/index.js" /* webpackChunkName: "component---src-pages-disclaimer-index-js" */),
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-templates-marktdaten-index-js": () => import("./../../../src/templates/marktdaten/index.js" /* webpackChunkName: "component---src-templates-marktdaten-index-js" */)
}

